import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=50649228"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kasingkhoo/Projects/PECOS/pecos_ivm_apiserver-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50649228')) {
      api.createRecord('50649228', component.options)
    } else {
      api.reload('50649228', component.options)
    }
    module.hot.accept("./BarChart.vue?vue&type=template&id=50649228", function () {
      api.rerender('50649228', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Chart/BarChart.vue"
export default component.exports